import React from 'react';
import NewStudent from './NewStudent';
import '../../../CommonCSS/SocietyCSS.css'


const NewStudentApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Add Student </h5>
          </div>
        </div>
        <NewStudent/>
      </div>
    </div >
  );
};

export default NewStudentApp;
